// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import ElementUI, {MessageBox} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {doGet} from '@/util/request'
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import VXETablePluginElement from 'vxe-table-plugin-element';
import VXETablePluginMenus from 'vxe-table-plugin-menus';
import tableOperateConfigMixin from './mixin/table-operate-config-mixin';
import {
  CLEAR_FIXED_COLUMN,
  COPY_CODE,
  FIXED_LEFT_COLUMN, FIXED_RIGHT_COLUMN,
  PASTE_CODE,
  TABLE_SETTING_STYLE
} from '@/component/x-table/table-setting-constant';
import RuleError from '@/util/RuleError';
import RequestError from '@/util/RequestError';
import NonsenseError from '@/util/NonsenseError';
import FormItem from '@/component/x-form-item/FormItem.vue';
import ElDialog from '@/component/x-dialog/ElDialog';
import XUpload from '@/component/x-upload/x-upload.vue';
import XUploadDialog from "@/component/x-upload-dialog/x-upload-dialog.vue";
import XButtonGroup from "@/component/x-button-group/x-button-group.vue";
import XCondition from "@/component/x-condition/x-condition.vue";
import XListPage from "@/component/x-list-page/x-list-page.vue";
import XListPageDialog from "@/component/x-list-page-dialog/x-list-page-dialog.vue";
import XIcon from '@/component/x-icon/Icon.vue';
import XPageContainer from '@/component/x-page-container/x-page-container.vue';
import XTable from '@/component/x-table/x-table.vue';
import XDownloadDialog from '@/component/x-download-dialog/x-download-dialog.vue';
import XTableSettingDialog from '@/component/x-table-setting-dialog/x-table-setting-dialog.vue';
import DetailDialog from '@/component/detailDialog/DetailDialog.vue';
import SysLogDialog from '@/component/sys-log/SysLogDialog.vue';
import XSearchList from '@/component/x-search-list/x-search-list.vue';
import XSearchOption from '@/component/x-search-option/x-search-option.vue';
// import '@/component/vxe-table-pro/vxe-table-pro.es6.min';
// import '@/component/vxe-table-pro/vxe-table-pro.scss';
import '@/icon/iconfont/iconfont.css';
import '@/style/element-variables.scss'
import '@/style/index.scss';
import '@/style/theme/_index.scss';
import 'viewerjs/dist/viewer.css';
import XMultipleTabListPage from "@/component/x-multiple-tab-list-page/x-multiple-tab-list-page.vue";
import XDialog from '@/component/x-dialog';
import storage from '@/util/storage';
import {getLoginInfo} from '@/util/user';
import {collectErrorInfo} from '@/util/appUtils';
import {frontLogApi} from '@/api/log/log';
// 放在全局作用域方便调用
window.RuleError = RuleError;
window.RequestError = RequestError;
window.NonsenseError = NonsenseError;
/**
 * 是不是本地错误
 * @param err
 * @return {boolean}
 */
const isLocalError = ({err}) => {
  if (err instanceof RuleError || err instanceof NonsenseError) {
    return true;
  }
  // ResizeObserver loop limit exceeded
  // 如果在一个动画帧内，ResizeObserver不能处理所有的observations，就会触发这个ResizeObserver loop limit exceeded
  // ResizeObserver loop completed with undelivered notifications.
  if (err.message && err.message.startsWith('ResizeObserver loop')) {
    return true;
  }
  // cancel,false,error这些值有可能是element-ui的弹窗触发的
  if (err === 'cancel' || err === false || err === 'error') {
    return true;
  }
  return false;
};
// 错误的事件监听
window.addEventListener('error', (event) => {
  console.error('error', event);
  const error = event.error || event;
  if (isLocalError({err: error})) {
    return;
  }
  const obj = collectErrorInfo({err: error});
  const loginInfo = getLoginInfo();
  if (loginInfo != null && loginInfo.sysUser != null) {
    obj.creator = loginInfo.sysUser.id;
    obj.creatorName = loginInfo.sysUser.userName;
  }
  frontLogApi(obj);
});
window.addEventListener('unhandledrejection', (event) => {
  console.error('unhandledrejection', event);
  const reason = event.reason;
  if (isLocalError({err: reason})) {
    return;
  }
  const obj = collectErrorInfo({err: reason});
  const loginInfo = getLoginInfo();
  if (loginInfo != null && loginInfo.sysUser != null) {
    obj.creator = loginInfo.sysUser.id;
    obj.creatorName = loginInfo.sysUser.userName;
  }
  frontLogApi(obj);
});
Vue.config.errorHandler = (err, vm, info) => {
  console.error('errorHandler', err, vm, info);
  if (isLocalError({err})) {
    return;
  }
  const obj = collectErrorInfo({err, vm, info});
  const loginInfo = getLoginInfo();
  if (loginInfo != null && loginInfo.sysUser != null) {
    obj.creator = loginInfo.sysUser.id;
    obj.creatorName = loginInfo.sysUser.userName;
  }
  frontLogApi(obj);
};
Vue.use(VueRouter);
Vue.use(ElementUI, { size: 'mini' });
VXETable.use(VXETablePluginElement);
VXETable.use(VXETablePluginMenus);
VXETable.setup({ size: 'mini', authId: 'odklkwp2ua4htp7j',
  // vxe-table更新，需要增加这个配置，表格fullValidate方法校验失败才会返回状态为reject的promise
  validToReject: 'obsolete'});
Vue.use(VXETable);
Vue.component(FormItem.name, FormItem);
Vue.component(XDialog.name, XDialog);
Vue.component(ElDialog.name, ElDialog);
Vue.component(XUpload.name, XUpload);
Vue.component(XUploadDialog.name, XUploadDialog);
Vue.component(XButtonGroup.name, XButtonGroup);
Vue.component(XCondition.name, XCondition);
Vue.component(XListPage.name, XListPage);
Vue.component(XListPageDialog.name, XListPageDialog);
Vue.component(XIcon.name, XIcon);
Vue.component(XPageContainer.name, XPageContainer);
Vue.component(XTable.name, XTable);
Vue.component(XDownloadDialog.name, XDownloadDialog);
Vue.component(XTableSettingDialog.name, XTableSettingDialog);
Vue.component(DetailDialog.name, DetailDialog);
Vue.component(SysLogDialog.name, SysLogDialog);
Vue.component(XSearchOption.name, XSearchOption);
Vue.component(XSearchList.name, XSearchList);
Vue.component(XMultipleTabListPage.name, XMultipleTabListPage);

Vue.config.productionTip = false

tableOperateConfigMixin.props.menuConfig.default = () => {
  return {
    body: {
      options: [
        [
          { code: COPY_CODE, name: '复制 (Ctrl+C)', prefixIcon: 'el-icon-document-copy' },
          { code: PASTE_CODE, name: '粘贴 (Ctrl+V)', prefixIcon: 'fa fa-paste' }
        ]
      ]
    },
    header: {
      options: [
        [
          { code: TABLE_SETTING_STYLE, name: '表格样式', prefixIcon: 'el-icon-setting' },
          { code: FIXED_LEFT_COLUMN, name: '将列固定到左侧', prefixIcon: 'fa fa-paste' },
          { code: FIXED_RIGHT_COLUMN, name: '将列固定到右侧', prefixIcon: 'fa fa-paste' },
          { code: CLEAR_FIXED_COLUMN, name: '清除固定列', prefixIcon: 'fa fa-paste' }
        ]
      ]
    }
  };
};
async function isAuthenticated() {
  let result = await doGet('/api/auth/sysUser/isLogin');
  if (result.code === 1001) {
    return false;
  }
  if (result.code === 1) {
    return true;
  }
  return result.data;
}

router.beforeEach(async (to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  // 检查路由元信息是否需要认证
  if (!to.meta.requiresAuth) {
    next();
    return;
  }
  // 如果本地没有用户缓存信息，就跳转到登录页面
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    next('/login');
    return;
  }
  if (!await isAuthenticated()) {
    MessageBox.confirm('当前登录已失效，请重新登录', "提示", {
      type: 'warning',
      confirmButtonText: '确定'
    }).finally(() => {
      next('/login');
    });
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});

// 检查版本
const checkVersion = async () => {
  try {
    const res = await window.fetch('/appInfo.json?t=' + Date.now());
    console.log('appInfo', res);
    const data = await res.json();
    console.log('data', data);
    if (!data) {
      return;
    }
    // 如果本地没有记录，就看作是第一次，直接写入appBuildTime
    const localBuildTime = storage.get('appBuildTime');
    if (!localBuildTime) {
      storage.save('appBuildTime', data.appBuildTime);
      return;
    }
    // 本地的appBuildTime和远程的appBuildTime一致，就不再检查了
    if (data.appBuildTime + '' === localBuildTime + '') {
      return;
    }
    storage.save('appBuildTime', data.appBuildTime);
    await MessageBox.confirm('当前版本有更新，请刷新页面！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    window.location.reload();
  } finally {
    // 每分钟检查一次
    setTimeout(checkVersion, 60 * 1000);
  }
};
if (process.env.NODE_ENV === 'production') {
  setTimeout(checkVersion, 1000);
}